import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'mcrai-input[type=text], mcrai-input[type=password], mcrai-input[type=textarea]',
  template: `<div
  class="mcrai-input__field"
  [class.mcrai-input__field--placeholder]="hasPlaceholder()"
>
  <input
    *ngIf="type === 'text' || type === 'password'"
    class="mcrai-input__element"
    [formControl]="control"
    [type]="type"
    (focus)="onFocus()"
    (blur)="onBlur()"
  >
  <textarea
    *ngIf="type === 'textarea'"
    class="mcrai-input__element"
    [formControl]="control"
    [rows]="rowsCount"
    (keyup)="onKeyUp($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  ></textarea>
  <label
    class="mcrai-input__placeholder"
    [class.mcrai-input__placeholder--empty]="isEmpty()"
    [class.mcrai-input__placeholder--focused]="isFocused"
  >{{ placeholder }}</label>
</div>
<div class="mcrai-input__underline--wrapper">
  <div
    class="mcrai-input__underline"
    [class.mcrai-input__underline--focused]="isFocused"
    [class.mcrai-input__underline--active]="isActive()"
    [class.mcrai-input__underline--error]="hasErrors()"
  ></div>
</div>
<div class="mcrai-input__error" *ngIf="hasErrors()">
  {{ getFirstError() }}
</div>

`,
  styles: [`.mcrai-input{display:block}.mcrai-input__field{position:relative;margin-top:3px}.mcrai-input__field--placeholder{padding-top:15px}.mcrai-input__element{width:100%;padding:0;background:0 0;border:0;outline:0;font-size:16px;resize:none;overflow:hidden;line-height:18px}.mcrai-input__placeholder{position:absolute;left:0;-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:bottom left;transform-origin:bottom left;transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);pointer-events:none}.mcrai-input__placeholder--focused,.mcrai-input__placeholder:not(.mcrai-input__placeholder--empty){-webkit-transform:translateY(-1.35em) scale(.75);transform:translateY(-1.35em) scale(.75)}.mcrai-input__underline--wrapper{width:100%;height:1px}.mcrai-input__underline{width:100%;height:1px;-webkit-transform:scaleX(0);transform:scaleX(0);transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s;transition-timing-function:cubic-bezier(.25,.8,.25,1)}.mcrai-input__error{font-size:14px;padding-top:3px}`],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-input]': 'true',
    '[class.mcrai-input--text]': 'true'
  }
})
export class TextComponent implements OnInit {
  readonly UNDEFINED_ERROR = 'Byl spuÅ¡tÄn validÃ¡tor, kterÃ½ nemÃ¡ Å¾Ã¡dnou zprÃ¡vu! JmÃ©no validÃ¡toru: ';

  private _isFocused = false;
  get isFocused(): boolean {
    return this._isFocused;
  }

  private _rowsCount: number = 1;
  get rowsCount(): number {
    return this._rowsCount;
  }

  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() errors: string | ValidationErrors;
  @Input() type: string;

  constructor() { }

  ngOnInit() { }

  public hasPlaceholder(): boolean {
    return !!this.placeholder;
  }

  public hasErrors(): boolean {
    return this.control.dirty && this.control.invalid;
  }

  public isActive(): boolean {
    return this.isFocused || this.hasErrors();
  }

  public isEmpty(): boolean {
    if (!this.control) {
      return true;
    }

    if (Array.isArray(this.control.value) && this.control.value.length === 0) {
      return true;
    }

    if (this.control.value === 0 || this.control.value === '0') {
      return false;
    }

    return !this.control.value;
  }

  public getFirstError(): string {
    if (typeof this.errors === 'string') {
      return this.errors;
    }

    const keys = Object.keys(this.control.errors);

    return this.errors && this.errors.hasOwnProperty(keys[0]) ? this.errors[keys[0]] : this.UNDEFINED_ERROR + keys[0];
  }

  public onFocus(): void {
    this._isFocused = true;
  }

  public onBlur(): void {
    this._isFocused = false;
  }

  public onKeyUp(event: KeyboardEvent): void {
    const lineCount = this.control.value.split(/\r|\r\n|\n/).length;

    switch (event.code) {
      case 'Enter':
        if (this._rowsCount <= lineCount) {
          this._rowsCount++;
        }
        return;
      case 'Backspace':
      case 'Delete':
        if (this._rowsCount > lineCount) {
          this._rowsCount = lineCount;
        }
    }

  }

}
